///////////////////////////////////////////////////////////   FONTAWESOME
import { faPlayCircle, faTable, faList, faQuestionCircle, faCamera, faComment } from '@fortawesome/free-solid-svg-icons';
export const _SETTINGS = {
  basic: {
    generalPlayerName: 'MediaPlayer',
    frameRate: 25,
    imgFormat: 'png',
    imgMime: 'image/png'
  },
  sprite: {
    cols: 24,
    rows: 36
  },
  playerType: {
    standard: 'standard',
    embed: 'embed'
  },
  sideMenu: {
    felvetel: {
      icon: faPlayCircle,
      name: 'Felvétel'
    },
    musor: {
      icon: faTable,
      name: 'Műsor'
    },
    lista: {
      icon: faList,
      name: 'Lista'
    },
    kep: {
      icon: faCamera,
      name: 'Kép'
    },
    lightTable: {
      icon: faTable,
      name: 'Bélyegkép'
    },
    comment: {
      icon: faComment,
      name: 'Elfogadás' // comment modul
    },
    help: {
      icon: faQuestionCircle,
      name: ''
    }
  },
  snap: {
    ok: 'Ez lesz a fájl neve: ',
    minLength: 2,
    maxLength: 50
  },
  audio: {
    peak: 'loaded peaks! sample_rate: '
  },
  err: {
    init: 'Error in MediaPlayer init!',
    conf: 'Error in config!',
    router: 'A router rossz címet kapott!',
    snap: {
      tooShort: 'Túl rövid név!',
      tooLong: 'Túl hosszú név!'
    },
    review: 'Review hiba!',
    reviewGet: 'Hiba a review lekérésekor!',
    reviewPost: 'Hiba a review küldésekor!',
    audio: {
      gen: 'Audio player error: ',
      http: 'HTTP error '
    }
  }
};
